import { getUserNotificationsCount } from "@/api/area";
import NotificationIcon from "@/assets/SVG/notificationIcon";
import UserIcon from "@/assets/SVG/userIcon";
import { Box, Grid, IconButton } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function CardTitleGroup({ pic, onClick }) {
  const navigate = useNavigate();
  const [notificationsCount, setNotificationsCount] = useState(0);

  const fetchNotificationsCount = useCallback(() => {
    getUserNotificationsCount().then((res) => {
      setNotificationsCount(res);
    });
  }, []);

  useEffect(() => {
    fetchNotificationsCount();
  }, []);

  return (
    <>
      <Box padding="9px" borderRadius="22px">
        <Grid alignItems="center" display={"flex"} gap={"10px"}>
          {/* <Box
            alignItems="center"
            justifyContent={"space-between"}
            display={"flex"}
          >
            <img
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                border: "solid 1px #126E839C",
                objectFit: "cover",
              }}
              src={pic}
            />
            <Box mr="10px">
              <Typography fontSize={"14px"}>{name}</Typography>
              <Typography fontSize={"14px"} color="var(--emr-disable)">
                {titr}
              </Typography>
            </Box>
          </Box> */}
          <IconButton
            sx={{
              width: "40px",
              height: "40px",
              borderRadius: "8px",
              backgroundColor: "var(--emr-background-silver)",
              position: "relative",
            }}
            onClick={() => navigate("/user-notifications")}
          >
            <p
              style={{
                position: "absolute",
                top: "-6px",
                backgroundColor: "var(--emr-primary)",
                borderRadius: "50%",
                width: "15px",
                height: "15px",
                left: "-3px",
                color: "white",
                fontSize: "11px",
                lineHeight: "15px",
                margin: 0,
                textAlign: "center",
              }}
            >
              {notificationsCount}
            </p>
            <NotificationIcon />
          </IconButton>
          {pic && (
            <img
              onClick={onClick}
              src={pic}
              style={{ width: "35px", height: "35px", cursor: "pointer" }}
            />
          )}
          {!pic && (
            <IconButton
              onClick={onClick}
              sx={{
                width: "40px",
                height: "40px",
                borderRadius: "8px",
                backgroundColor: "var(--emr-background-silver)",
              }}
            >
              <UserIcon color={"var(--emr-primary-color-text)"} />
            </IconButton>
          )}
        </Grid>
      </Box>
    </>
  );
}
